import { IconMagicSolid, Text, TextLoader } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { GlobalSearchLoadingContentStyled } from './styles/GlobalSearchLoadingContentStyled'
import { GlobalSearchLoadingHeadingStyled } from './styles/GlobalSearchLoadingHeadingStyled'
import { GlobalSearchLoadingItemStyled } from './styles/GlobalSearchLoadingItemStyled'

const SKELETON_ROW_COUNT = 6

const SkeletonRow = () => (
  <GlobalSearchLoadingItemStyled>
    <TextLoader width={48} height={48} />
    <GlobalSearchLoadingContentStyled>
      <TextLoader width={300} height={12} />
      <TextLoader width={200} height={12} />
    </GlobalSearchLoadingContentStyled>
  </GlobalSearchLoadingItemStyled>
)

export const GlobalSearchLoadingState = () => {
  const intl = useProcurifyIntl()

  return (
    <div>
      <GlobalSearchLoadingHeadingStyled role='status' aria-live='polite'>
        <IconMagicSolid size={16} color='ai' />
        <Text inline color='ai'>
          {intl.formatMessage(messages.loadingMessage)}
        </Text>
      </GlobalSearchLoadingHeadingStyled>
      <div aria-hidden='true'>
        {Array.from({ length: SKELETON_ROW_COUNT }, (_, i) => (
          <SkeletonRow key={i} />
        ))}
      </div>
    </div>
  )
}
